import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const User = Loadable(lazy(() => import('./User')));
const UserDetailPage = Loadable(lazy(() => import('./UserDetailPage')));
const AddUser = Loadable(lazy(() => import('./AddUser')));

const UserRoutes = [
	{
		path: '/user',
		element: <User />,
		auth: authRoles.admin,
	},
	{
		path: '/dashboard/default/userdetail',
		element: <UserDetailPage />,
		auth: authRoles.admin,
	},
	{
		path: '/adduser',
		element: <AddUser />,
		auth: authRoles.admin,
	},
];

export default UserRoutes;
